import { FC } from 'react';
import colors from 'constants/colors';
import { ENV_CONFIG } from 'config/environment';
import { IPage } from 'store/pages/types';

export type TopIssueCardIssue = Partial<IPage> & {
  page_cta?: string;
};

interface Props {
  issue: TopIssueCardIssue;
  primaryColor?: string;
  edgeColor?: string;
  ctaColor?: string;
  tertiaryColor?: string;
  cardHelperText?: string;
  cardRaisedAlt?: string;
  cardGoalAlt?: string;
}

export const TopIssueCard: FC<Props> = ({
  issue,
  primaryColor = colors.inkBlue,
  edgeColor = colors.inkBlue,
  ctaColor = colors.oathBlue,
  tertiaryColor = colors.oathBlue,
  cardHelperText = 'WHY THIS MATTERS',
  cardRaisedAlt = 'Raised',
  cardGoalAlt = 'Goal',
}) => {
  const displayBar = issue.display_fundraising_bar ?? true;

  const iconUrl =
    issue.has_community_image && issue.id
      ? `${ENV_CONFIG().CLOUD_STORAGE.URL}/${ENV_CONFIG().CLOUD_STORAGE.TAGS}/icon/tag_${issue.id}.png`
      : null;

  return (
    <div className="top-issue-wrapper">
      <div className="top-issue-container top-issue-small-card" style={{ borderColor: edgeColor }}>
        <div className="top-issue-content">
          <span className="top-issue-eyebrow" style={{ color: primaryColor }}>
            {issue.page_category || 'TOP ISSUE'}
          </span>
          <div className="top-issue-title-row">
            {iconUrl && <img src={iconUrl} alt="" className="top-issue-image" />}
            <span className="top-issue-title" style={{ color: primaryColor }}>
              {issue.value}
            </span>
          </div>
          {displayBar && (
            <>
              <div className="top-issue-bar-labels">
                <span className="top-issue-body" style={{ color: primaryColor }}>
                  $— {cardRaisedAlt}
                </span>
                <span className="top-issue-body" style={{ color: primaryColor }}>
                  {cardGoalAlt} $—
                </span>
              </div>
              <div className="top-issue-progress-rail">
                <div
                  className="top-issue-progress-track"
                  style={{
                    width: '75%',
                    backgroundColor: primaryColor,
                  }}
                />
              </div>
            </>
          )}
          <div className="top-issue-footer">
            <button
              type="button"
              className="top-issue-donate-btn"
              style={{ backgroundColor: ctaColor }}
            >
              Donate
            </button>
            <div className="top-issue-line" />
            <span className="top-issue-eyebrow top-issue-why-label" style={{ color: primaryColor }}>
              {cardHelperText}
            </span>
            <p className="top-issue-body top-issue-cta-text" style={{ color: primaryColor }}>
              {issue.page_cta && issue.page_cta.length > 155
                ? `${issue.page_cta.slice(0, 155)}...`
                : issue.page_cta || 'This issue matters for the community.'}
            </p>
            <span
              className="top-issue-learn-more"
              style={{
                color: primaryColor,
                ['--learn-more-hover' as string]: tertiaryColor,
              }}
            >
              Learn More
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
